import React, { useState, useEffect } from "react";
import ReusableTable from "../../components/Employee/Table";
import DateRange from "../../components/Employee/AttendanceSummary/DateRange";
import { formatDateOnly, getDateMonthsAgo } from "../../util/common";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";

function AttendanceLayout() {
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [pageCount, setPageCount] = useState(1);

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [filter, setFilter] = useState({
    DateFrom: formatDateOnly(getDateMonthsAgo(1)),
    DateTo: formatDateOnly(new Date()),
    OrderBy: "desc",
  });

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  const tableColumns = [
    { accessorKey: "AttendanceDate", header: "Employee" },
    { accessorKey: "AttendanceDate", header: "Department" },
    { accessorKey: "AttendanceDate", header: "Attendance Date" },
    { accessorKey: "TimeIn", header: "Time In" },
    { accessorKey: "TimeOut", header: "Time Out" },
    { accessorKey: "TotalHours", header: "Total Hours" },
    { accessorKey: "TimeOut", header: "Source" },
  ];

  return (
    <div className="overtime-form-container">
      <h2>Employee Attendance Logs</h2>
      <form className="overtime-form">
        <div className="form-column">
          <SelectInput
            label="Employee Name"
            choices={[{ id: 1, name: "Jimboy Reyes" }]}
            onChange={(val) => {}}
          />
          <SelectInput
            label="Department"
            choices={[{ id: 1, name: "HR & Admin" }]}
            onChange={(val) => {}}
          />
        </div>

        <div className="form-column">
          <DateInput label="Date From" onChange={(val) => {}} />
          <DateInput label="Date To" onChange={(val) => {}} />
        </div>

        <div className="form-group full-width file-upload-section">
          <div className="attendance-filters">
            <div className="attendance-records">
              <ReusableTable
                data={[]}
                columns={tableColumns}
                mode="server"
                initialPageSize={pagination.pageSize}
                onPageChange={handleOnPageChange}
                pageCount={pageCount}
                page={pagination.page - 1}
                pageSize={pagination.pageSize}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AttendanceLayout;
